'use client';

import { T } from '@/i18n/LocaleProvider';
import MuiButton from '@mui/material/Button';
import Link from 'next/link';

export default function Button({
  children,
  variant = 'contained',
  href,
  external = false,
  onClick,
  disabled = false,
  size = 'medium',
  fullWidth = false,
  startIcon,
  endIcon,
  arrow = false,
  className = '',
  ...props
}) {
  const muiVariant =
    variant === 'ghost'
      ? 'outlined'
      : variant === 'link'
        ? 'text'
        : 'contained';

  const linkProps =
    href && !external ? { component: Link, href } : href ? { href } : {};

  return (
    <MuiButton
      variant={muiVariant}
      color="primary"
      onClick={onClick}
      disabled={disabled}
      size={size}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      className={className}
      {...linkProps}
      {...props}
    >
      <T>{children}</T>
      {arrow && muiVariant === 'contained' && (
        <svg
          aria-hidden="true"
          width="16"
          height="12"
          viewBox="0 0 16 12"
          fill="none"
          style={{ marginLeft: 8, flexShrink: 0 }}
        >
          <path
            d="M1 6H15M10 1L15 6L10 11"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </MuiButton>
  );
}
